var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-card-title',{staticClass:"pl-0"},[_c('h2',{staticClass:"title pl-0"},[_vm._v("Home")])]),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('system-note-widget',{})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('my-orders-widget',{attrs:{"widgetConfiguration":{
          name: 'my-open-requests-widget',
          title: 'My Open Requests',
          emptyMessage: 'You currently have no open requests.',
          showCommand: true,
          query: {
            orderStatus: 'Open',
            sortColumn: 'entryDateTime',
            sortDirection: 'descend',
            propertyId: _vm.currentPropertyId
          }
        }}})],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('my-orders-widget',{attrs:{"widgetConfiguration":{
          name: 'my-request-history-widget',
          title: 'Request History',
          emptyMessage: 'You do not have any history of completed requests.',
          showCommand: false,
          query: {
            orderStatus: 'Complete',
            sortColumn: 'entryDateTime',
            sortDirection: 'descend',
            propertyId: _vm.currentPropertyId
          }
        }}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }